import React, { useEffect, useState } from "react";
import "./Pagination.scss";
import PaginationControls from "./PaginationControls";
import PaginationTable from "./PaginationTable";
import Spinner from 'react-bootstrap/Spinner';

const Pagination = (props) => {
  const {
    tableHeading,
    lists,
    count,
    loadMore,
    typeOfTable,
    viewDetailslink,
    retrieveCheckedItems,
    handleOnAllItemsSelected,
    query,
    handleDownload,
    loader
  } = props;
  const [pageData, setpageData] = useState(lists); // InitialData at skip-0
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItems, setSelectedItems] = useState(new Map());
  const [totalPaginationCount, setTotalPaginationCount] = useState(count);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [paginationText, setpaginationText] = useState("");
  const [viewDetails, setViewDetails] = useState("");
  // This state is specifically for keeping track of the pages loaded - so that to avoid multiple API calls for loaded pages
  const [loadedPages, setLoadedPages] = useState(new Set([1]));
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const [selectedText, setSelectedtext] = useState(true);

  useEffect(() => {
    retrieveCheckedItems(allSelectedItems);
  }, [selectedItems]);

  useEffect(() => {
    fetchInitialData();
  }, [currentPage, lists]);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = pageData && pageData?.slice(startIndex, startIndex + itemsPerPage);

  useEffect(() => {
    // Reset currentPage to 1 whenever lists or query changes
    if(query && Object.keys(query).length > 0) {
      setCurrentPage(1);
      setLoadedPages(new Set([1]))
    } 
    else {
      setCurrentPage(1);
      setLoadedPages(new Set([1]))
    }
  }, [query]);


  useEffect(() => {
    setTotalPaginationCount(count);
  }, [count]);

  // This is to clear the selectedItems if filter/serach happens
  useEffect(() => {
    if (Object.keys(query)?.length > 0) {
      handleSelectNone();
      setSelectedItems(new Map());
      setIsSelectAll(false);
    }
  }, [query]);

  const getAllSelectedItems = () => {
    // Iterate over all pages and collect selected IDs
    let allSelectedItems = [];

    // Loop through each page in the selectedItems map
    selectedItems?.forEach((choosenItems) => {
      allSelectedItems = [...allSelectedItems, ...choosenItems]; // Append selected items from the page
    });

    return allSelectedItems;
  };

  const allSelectedItems = getAllSelectedItems();

  const fetchInitialData = () => {
    setpageData(lists);
  };

  // Handle on Page Navigation
  const changePage = async (direction) => {
    setIsSelectAll(false);
    let newPage = currentPage;
    if (direction === "next") {
      newPage = currentPage + 1;
    } else if (direction === "prev") {
      newPage = currentPage - 1;
    }

    // Call loadMore only for a new page
    if (!loadedPages.has(newPage)) {
      await loadMore();
      setLoadedPages((prev) => new Set(prev).add(newPage));
    }
    setCurrentPage(newPage);
  };

  const viewDetailsBtnClick = (id) => {
    if (id === viewDetails) {
      setViewDetails("");
    } else {
      setViewDetails(id);
    }
  };

  // const handleSelectAll = (action) => {
  //   setDropdownVisible(false);
  //   setSelectedItems((prev) => {
  //     const newMap = new Map(prev);

  //     // Get data only for the current page
  //     const currentPageEmails = pageData.slice(startIndex, startIndex + itemsPerPage);
  //     // currentPageEmails -> passes the data as an Object to the Parent Component

  //     if (isSelectAll) {
  //       // Deselect all items on the current page
  //       newMap.set(currentPage, []); // Clear selection for the current page
  //     } else {
  //       // Select all items on the current page
  //       newMap.set(currentPage, currentPageEmails); // Add only current page items
  //     }

  //     return newMap;
  //   });
  //   setIsSelectAll((prev) => !prev);
  //   setGlobalSelection(false);
  // };

  const handleSelectAll = () => {
    setDropdownVisible(false);
    setSelectedItems((prev) => {
      const newMap = new Map(prev);
      const currentPageEmails = pageData.slice(startIndex, startIndex + itemsPerPage);
      const isCurrentlySelected = (newMap.get(currentPage) || []).length === paginatedData.length;
  
      if (isCurrentlySelected) {
        newMap.set(currentPage, []); // Deselect all

      } else {
        newMap.set(currentPage, currentPageEmails); // Select all
      }
  
      return newMap;
    });
    setIsSelectAll((prev) => !prev);
  };
  
  const handleSelectNone = () => {
    const updatedSelectedEmails = new Map(selectedItems);
    updatedSelectedEmails?.set(currentPage, []);
    setSelectedItems(updatedSelectedEmails);
    setDropdownVisible(false);
    setIsSelectAll(false)
  };

  // This function gives the number of items selected in all Pages
  const getTotalSelectedItemsCount = () => {
    let totalCount = 0;
    selectedItems?.forEach((items) => {
      totalCount += items.length; 
    });
    return totalCount;
  };

  
  const handleSingleSelect = (email) => {
    handleOnAllItemsSelected(false);
    setSelectedtext(true)
      setSelectedItems((prev) => {
        const updated = new Map(prev);
    
        // Check if the item is already selected
        const isSelected = [...updated.values()].flat().some(
          (selectedRecord) => selectedRecord._id === email._id
        );
    
        if (isSelected) {
          // Remove the item
          updated.set(
            currentPage,
            (updated.get(currentPage) || []).filter((item) => item._id !== email._id)
          );
        } else {
          // Add the item
          updated.set(currentPage, [...(updated.get(currentPage) || []), email]);
        }
    
        return updated;
      });
  };


  // Functions for enabling and disabling of pagination Text

  const onSelectingAllItems = () => {
    setpaginationText(`All ${totalPaginationCount} ${typeOfTable === "NGO_TABLE" ? "Nonprofits" : "Users"} are selected. `);
    handleOnAllItemsSelected(true);
    setSelectedtext(false)
  };

  const handleClearSelection = () => {
    setpaginationText("");
    handleSelectNone();
    handleOnAllItemsSelected(false);
    // To remove the number of ngos selected logic
    setSelectedtext(true)
  };

  const renderPaginationText = () => {
    if (paginationText) {
      return (
        <p
          style={{
            textAlign: "center",
            padding: "5px",
            backgroundColor: "hsl(0,0%,95%)",
          }}
        >
          {paginationText}
          <span
            style={{ color: "#2196f3", paddingLeft: "5px", cursor: "pointer" }}
            onClick={handleClearSelection}
          >
            Clear Selection
          </span>
        </p>
      );
    }
  const selectedCount = (selectedItems?.get(currentPage) || []).length;

    if (selectedCount > 0) {
      return (
        <p
          style={{
            textAlign: "center",
            padding: "10px",
            backgroundColor: "hsl(0,0%,95%)",
            borderRadius: "4px",
          }}
        >
          {`All ${paginatedData.length} ${typeOfTable === "NGO_TABLE" ? "Nonprofits" : "Users"} on this page are selected. `}
          <span style={{ color: "#2196f3", cursor: typeOfTable === "NGO_TABLE" ? "not-allowed" : "pointer", }}
           onClick={typeOfTable === "STATUS_TABLE" || typeOfTable === "EMAIL_TABLE" ? onSelectingAllItems : null}
           >
            Select all {totalPaginationCount} {`${typeOfTable === "NGO_TABLE" ? "Nonprofits" : "Users"}`}
          </span>
        </p>
      );
    }

    return null;
  };

  return (
    <>
      <div className="row">
        <div className="card-col col-xl-12 col-12">
          <div className="ibox-content">
          {loader ? 
              <div style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                <Spinner animation="border" size="xl" />
                <span className='ml-2'>
                  Loading...
                 </span>
              </div>
            : pageData && pageData?.length > 0 ? (
              <>
                <div className="flex-container">
                  {isSelectAll && totalPaginationCount > 10 && <div className="item-1">{renderPaginationText()}</div>}
                  <PaginationControls
                    totalPaginationCount={totalPaginationCount}
                    changePage={changePage}
                    itemsPerPage={10}
                    currentPage={currentPage}
                    loader={loader}
                  />
                </div>
                <div style={{display:"flex"}}>
                {selectedItems && selectedItems.size > 0 && getTotalSelectedItemsCount() > 0 && selectedText &&  (
                      <p
                        className=""
                        style={{
                          textAlign: "center",
                          padding: "10px",
                          backgroundColor: "hsl(0,0%,95%)",
                        }}
                      >
                        {getTotalSelectedItemsCount()}{" "}
                        {getTotalSelectedItemsCount() === 1
                          ? typeOfTable === "NGO_TABLE"
                            ? "NGO is"
                            : "User is"
                          : typeOfTable === "NGO_TABLE"
                          ? "NGOs are"
                          : "Users are"}{" "}
                        selected
                      </p>
                )}
                </div>
                <PaginationTable
                  tableHeading={tableHeading}
                  typeOfTable={typeOfTable}
                  viewDetailsBtnClick={viewDetailsBtnClick}
                  viewDetails={viewDetails}
                  paginatedData={paginatedData}
                  currentPage={currentPage}
                  selectedItems={selectedItems}
                  toggleDropdown={() => setDropdownVisible(!isDropdownVisible)}
                  isDropdownVisible={isDropdownVisible}
                  handleSelectAll={handleSelectAll}
                  handleSelectNone={handleSelectNone}
                  handleSingleSelect={handleSingleSelect}
                  setIsDropdownVisible={setDropdownVisible}
                  handleDownload={handleDownload}
                />
              </>
            ) : (
              <div style={{ textAlign: "center" }}>No items available</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagination;
